import './styles.scss';

import React, { useContext, useEffect, useState } from 'react';

import { CoreContext, WindowContext } from '../../providers';
import { BankOfferContent } from './components/BankOfferContent';
import {
    BankOfferMiddlestep,
    getMiddlestep,
} from './components/BankOfferMiddlestep';

interface OfferPopupProps {
    middlestep: any;
    offers: any;
}

export const OfferPopup = ({
    middlestep: middlestepName,
    offers,
}: OfferPopupProps) => {
    const { closePopup } = useContext(CoreContext);

    const { currentMediaName } = useContext(WindowContext);

    /** @type {[Middlestep, React.Dispatch<React.SetStateAction<Middlestep>>]} */
    const [middlestep, setMiddlestep] = useState(null);

    const [middlestepEnabled, setMiddlestepEnabled] = useState(false);

    const [popupOffers, setPopupOffers] = useState([]);

    useEffect(() => {
        const savedMiddlestep = getMiddlestep(middlestepName);

        if (offers) {
            if (middlestepName) {
                setMiddlestepEnabled(true);
            } else {
                setPopupOffers(offers.primary_offers);
            }

            if (savedMiddlestep) {
                setPopupOffers(offers[savedMiddlestep]);
                /**
                 * Just hardcoded offers to make tests easier, it is safe to
                 * remove.
                 */
                // setPopupOffers(['lendo_restart_bolig', 'uno-finans-forbrukslan', 'mybank', 'uno-finans-omstartslan']);
            }
        }
    }, [middlestep]);

    const Content = () => (
        <>
            {currentMediaName === 'desktop' && (
                <div className="FactorOfferPopup__close-wrapper">
                    <button
                        type="button"
                        className="FactorOfferPopup__overlay-close"
                        onClick={() => closePopup()}
                    >
                        X
                    </button>
                </div>
            )}
            <div className="FactorOfferPopup__popup">
                {currentMediaName !== 'desktop' && (
                    <button
                        type="button"
                        className="FactorOfferPopup__close"
                        onClick={() => closePopup()}
                    >
                        X
                    </button>
                )}

                {middlestepEnabled && !popupOffers.length ? (
                    <BankOfferMiddlestep
                        setMiddlestep={setMiddlestep}
                        middlestepName={middlestepName}
                    />
                ) : (
                    <BankOfferContent popupOffers={popupOffers} />
                )}
            </div>
        </>
    );

    return <Content />;
};
